export const dLocalCardNumberId = 'd-local-card-number'

export const dLocalCardExpirationId = 'd-local-card-expiration'

export const dLocalCardIdentificationNumberId =
  'd-local-card-identification-number-id'

export const dLocalCardSecurityCodeId = 'd-local-card-security_code'
